import type { FC } from 'react';

import lolRoleBotIcon from 'app/icons/lol_role_bot.svg';
import lolRoleJunIcon from 'app/icons/lol_role_jun.svg';
import lolRoleMidIcon from 'app/icons/lol_role_mid.svg';
import lolRoleSupIcon from 'app/icons/lol_role_sup.svg';
import lolRoleTopIcon from 'app/icons/lol_role_top.svg';

interface Props extends ClassNameProp {
  role: LolPlayerRole;
}

const ROLES_ICON: Record<LolPlayerRole, SVG> = {
  adc: lolRoleBotIcon,
  jun: lolRoleJunIcon,
  mid: lolRoleMidIcon,
  sup: lolRoleSupIcon,
  top: lolRoleTopIcon
};

const LoLPlayerRoleIndicator: FC<Props> = ({ role, className }) => {
  const Icon = ROLES_ICON[role];
  return <Icon className={className} />;
};

LoLPlayerRoleIndicator.displayName = 'LoLPlayerRoleIndicator';

export default LoLPlayerRoleIndicator;
